import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Tabs, Tab, Container,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
  Tooltip
} from '@mui/material';
import { AuthContext } from '../..';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';


export default function ClientsMasterTypes() {
  const { permissions, token } = useContext(AuthContext);
  const [formdata, setFormdata] = useState({ tab: "1", value: "" });
  const [currentType, setCurrentType] = useState("Preferred Payment");
  const [activeTab, setActiveTab] = useState(1);

  const [preferredPaymentData, setPreferredPaymentData] = useState([]);
  const [paymentTermsData, setPaymentTermsData] = useState([]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const [editicon, setEditicon] = useState(true);
  const [deleteiocn, setDeleteicon] = useState(true);

  const handleTab = (e, value) => {
    setActiveTab(value);
    if (value === 1) {
      setCurrentType("Preferred Payment");
      setFormdata(prev => ({ ...prev, tab: "1" }));
    } else if (value === 2) {
      setCurrentType("Payment Terms");
      setFormdata(prev => ({ ...prev, tab: "2" }));
    }
  };

  const handler = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
  };

  const handleAdd = () => {
    if (!formdata.value?.trim()) return;

    axios.post(`${process.env.REACT_APP_API_LINKS}/clientmasters/addclients`, formdata,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => {
        if (res.status === 200) {
          Swal.fire({ icon: 'success', title: 'Added', text: 'Entry added successfully', timer: 1500, showConfirmButton: false });
          setFormdata(prev => ({ ...prev, value: "" }));
          refreshData();
        }
      })
      .catch(err => {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Already Exists or Failed', timer: 1500, showConfirmButton: false });
      });
  };

  const refreshData = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/clientmasters/getclients`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => {
        setPreferredPaymentData(res.data.preferredPayment || []);
        setPaymentTermsData(res.data.paymentTerms || []);
      })
      .catch(err => {
        console.error('Error fetching data:', err);
      });
  };

  const getCurrentData = () => {
    if (formdata.tab === "1") return preferredPaymentData;
    if (formdata.tab === "2") return paymentTermsData;
    return [];
  };

  const handleEditClick = (id, value) => {
    setEditId(id);
    setEditValue(value);
    setEditDialogOpen(true);
  };

  const handleUpdate = async () => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_LINKS}/clientmasters/updateclients/${editId}`, {
        value: editValue,
        tab: formdata.tab
      },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
      if (res.status === 200) {
        Swal.fire({ icon: 'success', title: 'Updated', timer: 1500, showConfirmButton: false });
        setEditDialogOpen(false);
        refreshData();
      }
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Update failed', timer: 1500, showConfirmButton: false });
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_API_LINKS}/clientmasters/deleteclients/${id}/${formdata.tab}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => {
        if (res.status === 200) {
          Swal.fire({ icon: 'success', title: 'Deleted', text: 'Entry deleted', timer: 1500, showConfirmButton: false });
          refreshData();
        }
      })
      .catch(err => {
        Swal.fire({ icon: 'error', title: 'Failed', text: 'Could not delete the item', timer: 1500, showConfirmButton: false });
      });
  };

  useEffect(() => {
    refreshData();
  }, []);

  const permissionsaccess = () => {
    const mastersmodule = permissions.masters || {};
    setDeleteicon(mastersmodule.delete === true);
    setEditicon(mastersmodule.update === true);
  };
  useEffect(() => {
    if (permissions && permissions.masters) {
      permissionsaccess();
    }
  }, [permissions]);

  return (
    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: 3,
      backgroundColor: '#ffffff',
      minHeight: 'calc(100vh - 64px)',
      borderRadius: 2,
      boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)' }
    }}>
      <Box sx={{ fontFamily: 'Open Sans' }}>
        <Tabs value={activeTab} onChange={handleTab} textColor="primary" indicatorColor="primary" variant="scrollable" sx={{ mb: 3 }}>
          <Tab label="Preferred Payment" value={1} sx={{ fontSize: { xs: '10px', sm: '14px' } }} />
          <Tab label="Payment Terms" value={2} sx={{ fontSize: { xs: '10px', sm: '14px' } }} />
        </Tabs>

        <Typography variant="h6" fontWeight={600} mb={1} textAlign="center">
          {currentType}
        </Typography>

        {permissions?.masters?.create &&
          <Box display="flex" gap={2} mb={2}>
            <TextField
              name="value"
              size="small"
              fullWidth
              value={formdata.value}
              onChange={handler}
              placeholder={`Add new ${currentType}`}
            />
            <Button variant="contained" sx={{ bgcolor: '#0b85c8' }} onClick={handleAdd}>
              Add
            </Button>
          </Box>
        }

        {getCurrentData().length > 0 && (
          <TableContainer component={Paper} sx={{
            mb: 2,
            overflow: 'auto',
            maxHeight: 'calc(100vh - 200px)',
            '&::-webkit-scrollbar': { width: '6px', height: '6px' }
          }}>
            <Table stickyHeader size='small'>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f0f9ff' }}>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>{currentType}</TableCell>
                  {(editicon || deleteiocn) && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>Actions</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {getCurrentData().map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell sx={{ textTransform: 'capitalize' }}>{item.value}</TableCell>
                    {(editicon || deleteiocn) && <TableCell>
                      {editicon && <Tooltip title="Edit">
                        <IconButton onClick={() => handleEditClick(item.id, item.value)}>
                          <EditIcon sx={{ color: '#0b85c8', fontSize: '18px' }} />
                        </IconButton>
                      </Tooltip>}
                      {deleteiocn && <Tooltip title="Delete">
                        <IconButton onClick={() => handleDelete(item.id)}>
                          <DeleteIcon sx={{ color: 'red', fontSize: '18px' }} />
                        </IconButton>
                      </Tooltip>}
                    </TableCell>}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} fullWidth maxWidth="sm">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
            <DialogTitle
              sx={{
                fontFamily: 'Open Sans',
                fontWeight: 600,
                p: 2,
                textAlign: 'center',
                color: '#0b85c8',
                fontSize: { lg: '20px', xs: '15px' },
                margin: 'auto'
              }}
            >
              Edit {currentType}
            </DialogTitle>
            <IconButton onClick={() => setEditDialogOpen(false)} sx={{ color: '#fff' }}>
              <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: "24px", borderRadius: 2, mr: 3 }} />
            </IconButton>
          </Box>
          <DialogContent sx={{ bgcolor: '#f0f9ff', mt: -3 }}>
            <Box sx={{ px: 3, pt: 1, bgcolor: '#ffff', borderRadius: 1, boxShadow: 1 }}>
              <TextField
                autoFocus
                fullWidth
                label={`${currentType} Name`}
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                sx={{ mt: 1 }}
              />
              <Box sx={{ textAlign: 'center' }}>
                <Button variant="contained" onClick={handleUpdate} sx={{ bgcolor: '#0b85c8', fontFamily: 'Open Sans', my: 2 }}>
                  Update
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
}
